import { Text, VStack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import type { TimeTrackingEntryFragment } from "@src/__generated__/graphql";
import { TimeBillingLink } from "@src/components/modules/projects/time-billing/components/time-billing-link";
import { Banner } from "@src/components/ui-kit/Banner/Banner";
import { useStore } from "@src/utils/hooks";
import { isInUnlockedTimeBilling } from "@src/utils/time-tracking/unlocked-time-billing";
import { observer } from "mobx-react-lite";

type TimeEntryTimeBillingBannerProps = {
  readonly item: Pick<TimeTrackingEntryFragment, "timeBilling">;
};

export const TimeEntryTimeBillingBanner = observer(
  function TimeEntryTimeBillingBanner({
    item,
  }: TimeEntryTimeBillingBannerProps) {
    const { workspaceStore } = useStore();
    const { timeBilling } = item;

    if (!timeBilling) return null;

    const isBlocking = isInUnlockedTimeBilling(
      item,
      workspaceStore.settings?.moduleSettings.time_billing ?? false,
    );

    return (
      <Banner
        data-testid="time-entry-time-billing-banner"
        mb="4"
        status={isBlocking ? "warning" : "info"}
        title={t`Locked Time Billing – editing is not allowed`}
        description={
          <VStack align="start" spacing="1">
            <TimeBillingLink
              projectId={timeBilling.project.id}
              timeBillingId={timeBilling.id}
              name={timeBilling.name}
            />
            {isBlocking && (
              <Text>
                <Trans>
                  This time entry is included in unlocked Time Billing and
                  cannot be edited, deleted, or moved. You can only change its
                  notes or exclude it from Time Billing first.
                </Trans>
              </Text>
            )}
          </VStack>
        }
      />
    );
  },
);
